import React from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import {Button, Checkbox, Form} from "semantic-ui-react";
import TxtLbl from "../../../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../../../components/Input/TextArea/TextAreaLbl";
import DrpDwn from "../../../../../components/Dropdown/Dropdown/DrpDwn";
import Lbl from "../../../../../components/Label/Lbl";
import CropImageUploader from "../../../../../components/CropImageUploader/index";
import FileUploader from "../../../../../components/FileUpload/FileUpload";
import IntlTelInput from "react-intl-tel-input";
import * as common from "../../../../../const/Common/CommonFunc";
import * as EmailValidator from "email-validator";
import * as util from "../../../../../util/Validator";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import {DatePicker, TimePicker} from "antd";
import './Styles.css';
import * as innerRoutes from '../InnerRoutes/InnerRoutes';
import apiConfig from '../../../../../axios/axios_api_services';
import axios_event from '../../../../../axios/axios_eventtag';
import Cookies from "js-cookie";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import {withRouter} from "react-router-dom";
import {notifyMessage} from "../../../../../const/Common/CommonFunc";
import success_icon from "../../../../../assets/img/sweet/success.svg";
import error_icon from "../../../../../assets/img/sweet/cry.svg";

const {RangePicker} = DatePicker;

class App extends React.Component {

  state = {
    name: "",
    description: "",
    catogary: "",
    privacy: "PRIVATE",
    has_sub_event: true,
    //event icon
    icon: "",
    //event brochure
    brochure: "",
    brochureLink: "",
    brochureName: "",
    //organizer
    organizer_name: "",
    organizer_mobile: "",
    is_valid_mobile: false,
    organizer_email: "",
    is_mail_valid: false
  };

  componentWillMount() {
    this.props.callAllEventCategories();
  }

  componentDidMount() {
  }

  onchangeHandler = name => event => {
    let value = event.target.value;
    switch (name) {
      case 'name':
        this.setState({name: value});
        break;
      case 'description':
        this.setState({description: value});
        break;
      case 'organizer_name':
        this.setState({organizer_name: value});
        break;
      case 'organizer_mobile':
        let onlyDigit = new RegExp("^\\d+$");
        if (onlyDigit.test(value) || value.length === 0) {
          let isValidMobile = util.mobileNumValidator(value, "ALL", 1);
          if (isValidMobile) {
            this.setState({
              is_valid_mobile: true,
              organizer_mobile: value
            });
          } else {
            this.setState({
              is_valid_mobile: false,
              organizer_mobile: value
            });
          }
        }
        break;
      case 'organizer_email':
        let validateEmail = EmailValidator.validate(value);
        if (validateEmail) {
          this.setState({
            organizer_email: value,
            is_mail_valid: true
          });
        } else {
          this.setState({
            organizer_email: value,
            is_mail_valid: false
          });
        }
        break;
      default:
        break;
    }
  };

  onPhoneNumberChange = e => {
    let value = e.target.value;
    let valid = false;
    if (value.length >= 9) {
      valid = true;
    }
    this.setState({
      organizer_mobile: value,
      is_valid_mobile: valid
    });
  };

  catogaryChangehandler = (e, {value}) => {
    this.setState({
      catogary: value
    });
  };

  privacyChangeHandler = () => {
    let value = (this.state.privacy === "PUBLIC") ? "PRIVATE" : "PUBLIC";
    this.setState({
      privacy: value
    });

  };

  hasSubEventChangeHandler = () => {
    this.setState({
      has_sub_event: !this.state.has_sub_event
    });

  };

  setIcon = (image, convert) => {
    this.setState({
      icon: convert
    });

  };

  setBrochure = (file, fileName, base64) => {
    this.setState({
      brochure: file,
      brochureLink: base64,
      brochureName: fileName
    });

  };

  toggle = () => {
  }

  validate = () => {
    var characters = new String(this.state.name.trim());
    characters.length > 100 ? common.notifyMessage("Event name must less than 100 characters") :
    this.state.name.trim() === '' ? common.notifyMessage("Please enter event name") :
      this.state.description.trim() === '' ? common.notifyMessage("Please enter event description") :
        this.state.catogary === ''? common.notifyMessage("Please select event category"):
        this.state.icon === '' ? common.notifyMessage("Please set event icon") :
          this.state.organizer_name.trim() === '' ? common.notifyMessage("Please enter organizer name") :
            this.state.organizer_mobile.trim() === '' ? common.notifyMessage("Please enter organizer contact") :
              !this.state.is_valid_mobile ? common.notifyMessage("Please enter valid organizer contact") :
                this.state.organizer_email.trim() === '' ? common.notifyMessage("Please enter organizer email") :
                  !this.state.is_mail_valid ? common.notifyMessage("Please enter valid organizer email") :
                    this.sendToBackEnd();
  };

  sendToBackEnd = () => {
    swal({
      title: "Do you want to proceed",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackEnd_();
            break;
          default:
        }
      });
  }

  sendToBackEnd_ = () => {
    this.props.pgChangeHandler(3);
    this.props.spinnerHandler(true);
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    let userId = this.props.usr_obj.userId;
    let event = {
      event_name: this.state.name,
      description: this.state.description,
      has_sub_event: this.state.has_sub_event,
      privacy: this.state.privacy,
      start_time: "",
      end_time: "",
      icon: this.state.icon,
      qr_code: "",
      invitation_image: "",
      brochure: null,
      category_id: this.state.catogary,
      corporate_id: corporateId,
      created_by: userId,
      event_contact_list: [
        {
          event_contact_id: 0,
          name: this.state.organizer_name,
          email: this.state.organizer_email,
          contact: this.state.organizer_mobile,
        }
      ]
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };
    axios_event.post(apiConfig.CREATE_CORPORATE_EVENTS({corporateId: corporateId}), event, {headers: headers})
      .then(response => {
        if(response.data.success){
          let event_id = response.data.event.event_id;
          let has_sub_event = response.data.event.has_sub_event;
          this.sendBrochureToBackEnd(event_id, has_sub_event, response.data.event);
        }else{
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackEnd_()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  sendBrochureToBackEnd = (event_id, has_sub_event, content) => {

    if(this.state.brochure!==undefined && this.state.brochure!==null && this.state.brochure!=="") {

      let file_upload_state = false;
      let catch_error = false;
      let brochureUrl = null;

      let formData = new FormData();
      formData.append('id', event_id);
      formData.append('file', this.state.brochure);
      formData.append('type', 'EVENT_BROCHURE_PDF');

      this.props.spinnerHandler(true);

      let corperateId = this.props.usr_obj.corporates[0].corporateId;

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
        'content-type': 'multipart/form-data'
      };
      axios_event.put(apiConfig.SEND_BROCHURE_FILES({corporateId: corperateId}), formData, {headers: headers})
        .then(response => {
          if(response.data.success){

            file_upload_state = true;
            catch_error = false;

            content.brochure = response.data.url;

          }else{

            common.warningAlert(response.data.message, 1);
            file_upload_state = false;
            catch_error = false;

          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.sendBrochureToBackEnd(event_id, has_sub_event, content)
          } else {
            file_upload_state = false;
            catch_error = true;
          }
        })
        .finally(fin => {

          if(file_upload_state) {

            this.props.setCurrentEventData(content);
            swal({
              title: "The event created successfully!",
              icon: success_icon,
              closeOnClickOutside: false,
              buttons: {
                dangerMode: {
                  text: "Okay",
                  value: "action",
                  className: "okay-btn"
                }
              }
            })
              .then((value) => {
                switch (value) {

                  case "action":
                    if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
                      if(has_sub_event){
                        this.props.history.push(innerRoutes.cor_inner_route_event_sub_events);
                      }else{
                        this.props.history.push(innerRoutes.cor_inner_route_events_event);
                      }
                    } else {
                      if(has_sub_event){
                        this.props.history.push(innerRoutes.inner_route_event_sub_events);
                      }else{
                        this.props.history.push(innerRoutes.inner_route_events_event);
                      }
                    }
                    break;
                  default:
                }
              });

          } else {
            if(catch_error) {
              swal({
                title: "The event created successfully! But, the Brochure upload failed.\"",
                icon: success_icon,
                closeOnClickOutside: false,
                buttons: {
                  dangerMode: {
                    text: "Okay",
                    value: "action",
                    className: "okay-btn"
                  }
                }
              })
                .then((value) => {
                  switch (value) {
                    case "action":
                      // this.props.history.push(innerRoutes.inner_route_allEvents);
                      this.props.closeModalAtError();
                      break;
                    default:
                  }
                });

            } else {
              this.props.setCurrentEventData(content);
              swal({
                title: "The event created successfully! But, the Brochure upload failed.\"",
                icon: error_icon,
                closeOnClickOutside: false,
                buttons: {
                  dangerMode: {
                    text: "Okay",
                    value: "action",
                    className: "okay-btn"
                  }
                }
              })
                .then((value) => {
                  switch (value) {
                    case "action":
                      if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
                        if(has_sub_event){
                          this.props.history.push(innerRoutes.cor_inner_route_event_sub_events);
                        }else{
                          this.props.history.push(innerRoutes.cor_inner_route_events_event);
                        }
                      } else {
                        if(has_sub_event){
                          this.props.history.push(innerRoutes.inner_route_event_sub_events);
                        }else{
                          this.props.history.push(innerRoutes.inner_route_events_event);
                        }
                      }
                      break;
                    default:
                  }
                });
            }
          }
          this.props.spinnerHandler(false);
        });

    } else {
      this.props.setCurrentEventData(content);
      swal({
        title: "The event created successfully!",
        icon: success_icon,
        closeOnClickOutside: false,
        buttons: {
          dangerMode: {
            text: "Okay",
            value: "action",
            className: "okay-btn"
          }
        }
      })
        .then((value) => {
          switch (value) {
            case "action":
              if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
                if(has_sub_event){
                  this.props.history.push(innerRoutes.cor_inner_route_event_sub_events);
                }else{
                  this.props.history.push(innerRoutes.cor_inner_route_events_event);
                }
              } else {
                if(has_sub_event){
                  this.props.history.push(innerRoutes.inner_route_event_sub_events);
                }else{
                  this.props.history.push(innerRoutes.inner_route_events_event);
                }
              }
              break;
            default:
          }
        });
    }


  };

  render() {
    let eventCategories = this.props.event_categories;
    let cat_Options = [];
      eventCategories.map((cat, index) => {
        let obj = {
          key: cat.event_category_id,
          text: cat.title,
          value: cat.event_category_id
        }
        cat_Options.push(obj);
      });

    let dateAndTime = "";
    if (!this.state.has_sub_event) {
      dateAndTime = <div>
        <Row>
          <Col lg={12}>
            <Lbl required>Event Date</Lbl>
            <RangePicker
              size={"mini"}
              // disabledDate={disabledDate}
              format="YYYY-MM-DD"
              // value = {dateRange}
              // onChange={this.dateRangeOnChange}
            />
          </Col>
        </Row>
        <Row className="TimePickerRow">
          <Col lg={5} className="TimePickerCol">
            <Lbl required>Event Start Time</Lbl>
            <TimePicker
              // value = {s_time}
              format="HH:mm"
              // onChange={this.startDateOnChange}
            />
          </Col>
          <Col lg={5}>
            <Lbl required>Event End Time</Lbl>
            <TimePicker
              // value = {e_time}
              format="HH:mm"
              // onChange={this.endDateOnChange}
            />
          </Col>
        </Row>
      </div>;
    }

    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Create New Event</MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '30px'}} className={"create-event"}>
              <Col lg={6} style={{padding: '16px'}}>
                <Form>
                  <Form.Group widths='equal'>
                    <TxtLbl
                      required
                      tagText={"Event Name"}
                      placeholder={"Event name"}
                      value={this.state.name}
                      onChange={this.onchangeHandler('name')}
                    />
                  </Form.Group>

                  <Form.Group widths='equal'>
                    <TxtAreaLbl
                      required
                      tagText={"Event Description"}
                      placeholder={"Event Description"}
                      value={this.state.description}
                      onChange={this.onchangeHandler('description')}
                    />
                  </Form.Group>

                  <Form.Group widths='equal'>
                    <DrpDwn
                      required
                      tagText={"Category"}
                      placeholder={"Select category"}
                      value={this.state.category}
                      options={cat_Options}
                      onChange={this.catogaryChangehandler}
                    />
                  </Form.Group>

                  <Row className="CheckBoxRow boldText">
                    <Col lg={5} className="TimePickerCol">
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                defaultChecked={(this.state.privacy === "public") ? false : true}
                                label='Make Private'
                                onChange={this.privacyChangeHandler}
                      />
                    </Col>
                  </Row>

                  <Row className="CheckBoxRow boldText">
                    <Col lg={5} className="TimePickerCol">
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                toggle
                                label='Has Sub Events'
                                defaultChecked={this.state.has_sub_event}
                                onChange={this.hasSubEventChangeHandler}
                      />
                    </Col>
                  </Row>
                </Form>

                <div>

                  <hr/>

                  <Row>
                    <Col lg={6}>
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            style={{marginTop: '10px'}}
                            required
                            tagText={"Event Organizer Name"}
                            placeholder={"Show in the app"}
                            value={this.state.organizer_name}
                            onChange={this.onchangeHandler('organizer_name')}
                          />
                        </Form.Group>
                      </Form>
                    </Col>

                    <Col lg="6">
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            style={{marginTop: '10px'}}
                            required
                            tagText={"Event Organizer Mobile"}
                            placeholder={"Show in the app"}
                            value={this.state.organizer_mobile}
                            onChange={this.onPhoneNumberChange}
                          />
                        </Form.Group>
                      </Form>
                    </Col>

                    <Col lg={12} style={{marginTop: '10px'}}>
                      <Form>
                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Event Organizer Email"}
                            placeholder={"Show in the app"}
                            value={this.state.organizer_email}
                            onChange={this.onchangeHandler('organizer_email')}
                          />
                        </Form.Group>
                      </Form>
                    </Col>

                  </Row>
                </div>
              </Col>

              <Col lg={6}
                   // className={{textAlign: 'center', padding: '0px'}}
              >
                <Row>
                  <Col xs="12" lg={"12"} md={"12"} className="textAlignCenter">
                    <Lbl required>Event Icon</Lbl>
                    <CropImageUploader propName="Event" image={this.state.icon} getImage={this.setIcon}/>
                  </Col>

                  <Col xs="12" lg={"12"} md={"12"} className="textAlignCenter">
                    <Lbl>Event Brochure</Lbl>
                    <FileUploader
                      fileStyle={"file1"}
                      key={'1'}
                      getFile={this.setBrochure}
                      preview={this.state.brochureName}
                      blink={this.state.brochureLink}
                    />
                  </Col>
                </Row>
              </Col>

            </Row>

            <Row>
              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                <Button className="px-5"
                        onClick={this.validate}
                >Create</Button>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>

    );

  }

}

const mapStateToProps = (state) => ({
  pg: state.eventReducer.pg,
  usr_obj: state.userReducer.user,
  event_categories: state.eventReducer.all_Event_Catogaries
});

const mapDispatchToProps = (dispatch) => {
  return {
    callAllEventCategories: () => dispatch(actionCreator.callAllEventCatogaries()),
    setCurrentEventData: (data) => dispatch(actionCreator.setCurrentEventData(data)),
    pgChangeHandler: (data) => dispatch(actionCreator.stepActivateionEventHandler(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));

